import { styled } from 'styled-components';

import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { RETAILER_COLORS, SCREEN_SIZE, SHADOWS } from '@components/web/src/styles';

export const HeaderFooterKioskContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;
  scrollbar-width: none;
  background-color: ${RETAILER_COLORS.secondary['100']};
  box-shadow: ${SHADOWS.xl};

  &::-webkit-scrollbar {
    width: 0;
  }
`;

export const BodyContainer = styled(Flexbox)`
  flex: 1 1;
  width: 100%;
  max-width: ${SCREEN_SIZE.KIOSK_WIDTH};
`;
